import {HttpAxiosRequest} from 'src/http/httpAxiosBase'
import {schemaNotificacionVista} from './schemas'
import {array} from 'zod'

const getEndpoint = (url = '') => `notificacion${url}`

export const HttpNotificacion = {
    getNotificacionesPorUsuario: () => {

        return HttpAxiosRequest.get(getEndpoint('')).then(res => {
            const parsed = array(schemaNotificacionVista).safeParse(res)

            if (!parsed.success) {
                return Promise.reject()
            }

            return Promise.resolve(parsed.data)
        })
    },
}
